"use client";

import { usePrefersLight } from "@/hooks/use-color-scheme";

/* The product visuals (phone, house, …) are dark device mockups built from
   hardcoded near-black shades. On the white light-theme card those read as heavy
   black objects, so we remap each shade to a medium gray in light mode. Mid-gray
   (not light-gray) keeps the white/green screen content readable and preserves
   the relative darkness of each face, so edges and openings still separate.
   Dark theme is left pixel-identical — the map only applies when light is on. */
const LIGHT_SHADE: Record<string, string> = {
  "#0a0b0d": "#565b62",
  "#0c0e10": "#585d64",
  "#101216": "#5b6067",
  "#121417": "#5d626a",
  "#16181c": "#636871",
  "#1a1d21": "#696e77",
  "#1e2025": "#6d727c",
  "#1e2125": "#6d727c",
  "#222529": "#717680",
  "#25292e": "#767b85",
  "#262b2f": "#777c86",
  "#272b30": "#787d88",
  "#2a2e33": "#7c818c",
  "#2e3338": "#808591",
  "#3a3e44": "#8a8f9a",
  "#454a51": "#9398a3",
};

/** Returns a shade mapper: identity in dark theme, near-black → medium gray in
 *  light theme. Pass any device hex used in these visuals. */
export function useDeviceShade(): (hex: string) => string {
  const light = usePrefersLight();
  return (hex: string) => (light ? (LIGHT_SHADE[hex.toLowerCase()] ?? hex) : hex);
}
